import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=3805734f&scoped=true"
import script from "./Employment.vue?vue&type=script&lang=js"
export * from "./Employment.vue?vue&type=script&lang=js"
import style0 from "./Employment.vue?vue&type=style&index=0&id=3805734f&prod&lang=scss&scoped=true"
import style1 from "./Employment.vue?vue&type=style&index=1&id=3805734f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3805734f",
  null
  
)

export default component.exports